import { Component } from '@angular/core';
import { ModalController, ViewController,NavController } from 'ionic-angular';
import { FormBuilder, Validators } from '@angular/forms';
import { UserBankService } from './../../services/userbank.service';
import { UserVarifyService } from './../../services/userVarify.service';
import { AlertService } from './../../providers/alert.service';
import { WithdrawKeyPage } from './withdrawKey';
import { LoaddingService } from './../../providers/loadding.service';
import { AddUserBank } from '../userbanks/adduserbank';

@Component({
  selector: 'page-withdraw',
  templateUrl: 'withdraw.html',
  providers: [
    UserBankService,
    UserVarifyService
  ]
})
export class WithdrawPage {

  constructor(
    public userBankService: UserBankService,
    private userVarifyService: UserVarifyService,
    private alertService: AlertService,
    private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private viewCtrl: ViewController,
    private loadding:LoaddingService,
    private navCtrl: NavController,

  ) { }
  key: string;
  sendForm = this.formBuilder.group({
    'passwordKey': ['', [Validators.required]]
  });

  //页面加载初期，判断是否绑定银行卡
  ionViewDidLoad() {
    // this.userBankService.getUserBank().then(s => {
    //   if (s == false) {
    //     this.alertService.showConfirms('您的账户未绑定，请绑定账户后提现', () => {
    //       this.navCtrl.push(AddUserBank);
    //     });
    // }
    // });
 
  }

  //输入密码进行验证
  //chen 2017-01-04
  keySub(obj) {
    let load=this.loadding.showLoding("提交中...");
    this.userVarifyService.getUserVarify(obj.passwordKey).then(s => {
      if (s) {
        let modal = this.modalCtrl.create(WithdrawKeyPage,{psw:obj.passwordKey});
        modal.present();
      } else {
        this.alertService.showAlert("密码输入有误，请重新输入");
      }
      this.loadding.closeLoading(load);
    }).catch(()=>{
      this.loadding.closeLoading(load);
    });
  }

  //页面返回
  //chen 2017-01-19
  close() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/withdraw/withdraw.ts